const LAUDIO_SELECTOR = '#lily-audio'
let laudio = null // 音频

export default function (options = {}) {
  let checkAudio = document.querySelector(LAUDIO_SELECTOR)
  if (checkAudio) {
    if (!checkAudio.ended) {
      checkAudio.pause()
    }
    checkAudio.removeAttribute('src')
    checkAudio.remove()
    laudio = null
    // return laudio
  }

  laudio = document.createElement('audio')
  laudio.id = 'lily-audio'
  laudio.loop = false
  laudio.src = options.src

  laudio.autoplay = options.autoplay || false

  laudio.addEventListener('error', function (e) {
    // err.code 1.用户终止 2.网络错误 3.解码错误 4.URL无效
    if (options.error) {
      options.error()
    } else {
      if (e.target) {
        console.log('err.code', e.code)
        alert('音频加载出错啦，请手动刷新')
      }
    }
  })

  laudio.addEventListener('ended', function () {
    checkAudio = document.querySelector(LAUDIO_SELECTOR)
    if (!checkAudio) {
      return
    }
    setTimeout(() => {
      if (!checkAudio.ended) {
        checkAudio.pause()
      }
      checkAudio.removeAttribute('src')
      checkAudio.remove()
      laudio = null
    }, 200)
  })

  document.body.appendChild(laudio)

  return laudio
}
